import { MenuCategory } from "@/hooks/useMenu";
import { ProductList } from "./ProductList";

function CategoriesList({ categories }: { categories: MenuCategory[] }) {
  return (
    <>
      <div data-category-list className="min-h-[40vh] flex flex-col md:gap-y-8">
        {categories.map((category) => {
          const hasProducts = category.products.length > 0;
          if (!hasProducts) return null;

          return (
            <div
              data-category
              key={category.name}
              className="menu-category border-solid mb-3"
              id={category.name}
            >
              <div className="flex justify-between items-center px-3 py-4 pb-0 md:pb-4">
                <h2 className="text-xl tracking-tighter font-medium">
                  {category.name}
                </h2>
              </div>

              <ProductList products={category.products} />
            </div>
          );
        })}
      </div>

      <div className="hidden peer-empty:flex items-center justify-center p-4 text-center text-muted-foreground w-full h-[40vh]">
        <h2>No products available</h2>
      </div>
    </>
  );
}

export { CategoriesList };
